import HeaderComponent from "../components/HeaderComponent"
import FooterComponent from "../components/FooterComponent"
import RegistrationComponent from "../components/RegistrationComponent"

const RegistrationPage = () => {
    return (
        <>
            <HeaderComponent/>
            <RegistrationComponent/>
            <FooterComponent/>
        </>
    )
}

export default RegistrationPage